import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../web/components-v2/Button';
import { sendErrorStyles } from '../styles/sendErrorStyles';

interface ComposerErrorBannerProps {
	message: string;
	onDismiss: () => void;
}

/** Dismissible warning banner shared by every composer send/AI failure notice. */
export const ComposerErrorBanner: React.FC<ComposerErrorBannerProps> = ({ message, onDismiss }) => (
	<div className={css(sendErrorStyles.banner)}>
		<span>{message}</span>
		<Button
			variant='ghost'
			size='sm'
			onClick={onDismiss}
			styles={[sendErrorStyles.dismissBtn]}
			title='Dismiss'
			aria-label='Dismiss error'
		>
			&times;
		</Button>
	</div>
);
